const UrineColors = [
  "Very Light Yellow",
  "Light Yellow",
  "Yellow",
  "Dark Yellow",
  "Reddish Yellow",
  "Orange",
  "Amber",
];

export default UrineColors;
